import { useState, useEffect } from 'react';
import AdTechPlatform from './AdTechPlatform';
import { api, setAuthToken } from './api';

function LoginPanel({ onLoggedIn }) {
  const [email, setEmail] = useState('admin@adtech.local');
  const [password, setPassword] = useState('admin123');
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setErr('');
    setLoading(true);
    try {
      const { data } = await api.post('/auth/login', { email, password });
      setAuthToken(data.accessToken);
      onLoggedIn(data.user);
    } catch (ex) {
      const d = ex.response?.data;
      const parts = [d?.message, d?.hint].filter(Boolean);
      setErr(parts.length ? parts.join(' — ') : ex.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#F7F9FC',
        fontFamily: 'system-ui, sans-serif',
      }}
    >
      <form
        onSubmit={submit}
        style={{
          background: '#fff',
          padding: 32,
          borderRadius: 12,
          boxShadow: '0 4px 24px rgba(15,23,42,0.08)',
          width: 360,
        }}
      >
        <h1 style={{ margin: '0 0 8px', fontSize: 22, color: '#0F172A' }}>AdTech Platform</h1>
        <p style={{ margin: '0 0 24px', fontSize: 14, color: '#64748B' }}>Sign in (demo: admin@adtech.local)</p>
        <label style={{ display: 'block', fontSize: 12, color: '#475569', marginBottom: 4 }}>Email</label>
        <input
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          type="email"
          style={{ width: '100%', padding: 10, marginBottom: 16, borderRadius: 8, border: '1px solid #E2E8F0' }}
        />
        <label style={{ display: 'block', fontSize: 12, color: '#475569', marginBottom: 4 }}>Password</label>
        <input
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          type="password"
          style={{ width: '100%', padding: 10, marginBottom: 16, borderRadius: 8, border: '1px solid #E2E8F0' }}
        />
        {err ? <p style={{ color: '#DC2626', fontSize: 13, marginBottom: 12 }}>{err}</p> : null}
        <button
          type="submit"
          disabled={loading}
          style={{
            width: '100%',
            padding: 12,
            borderRadius: 8,
            border: 'none',
            background: '#2563EB',
            color: '#fff',
            fontWeight: 600,
            cursor: loading ? 'wait' : 'pointer',
          }}
        >
          {loading ? 'Signing in…' : 'Sign in'}
        </button>
      </form>
    </div>
  );
}

export default function App() {
  const [user, setUser] = useState(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        // 401 without a session is expected — avoid axios rejecting so DevTools is less noisy
        const { status, data } = await api.get('/auth/me', {
          validateStatus: (s) => s === 200 || s === 401,
        });
        if (!cancelled && status === 200 && data?.user) setUser(data.user);
        else if (!cancelled) setAuthToken(null);
      } catch {
        setAuthToken(null);
      } finally {
        if (!cancelled) setChecking(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  if (checking) {
    return (
      <div style={{ padding: 48, textAlign: 'center', color: '#64748B', fontFamily: 'system-ui' }}>
        Loading…
      </div>
    );
  }

  if (!user) {
    return <LoginPanel onLoggedIn={setUser} />;
  }

  return (
    <>
      <div
        style={{
          position: 'fixed',
          top: 12,
          right: 12,
          zIndex: 99999,
          display: 'flex',
          gap: 8,
          alignItems: 'center',
          fontFamily: 'system-ui',
          fontSize: 12,
        }}
      >
        <span style={{ color: '#475569' }}>{user.email}</span>
        <button
          type="button"
          onClick={() => {
            setAuthToken(null);
            setUser(null);
          }}
          style={{
            padding: '6px 12px',
            borderRadius: 6,
            border: '1px solid #CBD5E1',
            background: '#fff',
            cursor: 'pointer',
          }}
        >
          Log out
        </button>
      </div>
      <AdTechPlatform />
    </>
  );
}
